import * as React from "react";
import { SvgIcon } from "@mui/material";

const MobileMenuIcon = () => {
    return (
        <SvgIcon
            version="1.0" xmlns="http://www.w3.org/2000/svg"
            width="44.000000pt" height="36.000000pt" viewBox="0 0 44.000000 36.000000"
            preserveAspectRatio="xMidYMid meet">
            <g transform="translate(0.000000,36.000000) scale(0.100000,-0.100000)"
                fill="#fff" stroke="none">
                <path d="M0 340 c0 -19 7 -20 140 -20 133 0 140 1 140 20 0 19 -7 20 -140 20
 -133 0 -140 -1 -140 -20z"/>
                <path d="M0 180 c0 -19 7 -20 220 -20 213 0 220 1 220 20 0 19 -7 20 -220 20
 -213 0 -220 -1 -220 -20z"/>
                <path d="M160 20 c0 -19 7 -20 140 -20 133 0 140 1 140 20 0 19 -7 20 -140 20
 -133 0 -140 -1 -140 -20z"/>
            </g>
        </SvgIcon>
    );
}

export default MobileMenuIcon;
